import React, { useEffect } from 'react';
import { Card } from 'react-bootstrap';
import './TrackOrder-Popup.css';
function TrackOrderPopup(props) {
  return (
    <>
      <div className="popup ex1" key={props.id}>
        <h2 className="fs-14 theme-col"></h2>

        <a className="close mb-1" onClick={() => props.popupVisibility()}>&times;</a>

        <div id="popupDescription" className='track_pop_des mt-3'>
          {props?.trackDetail?.length > 0 ? props?.trackDetail?.map((item, index) => {
            let dt = new Date(item.timestamp);
            let d = dt.toUTCString(item.timestamp);
            let newd;
            newd = d.substr(4, 12)
            return (
              index === 0 && item.status === "Delivered" ?
                <Card key={item.checkpoint_id} className="track_success_card">
                  <Card.Body>
                    <ul className='track_order_pop_ul'>
                      {index === 0 && item.status !== "Delivered" ?
                        <li className='fw-bold text-white'><img src="/icons8-truck.gif" className='w-5 h-5' alt="status" /> {item.status}</li> :
                        <li className='fw-bold text-white'><i className="bi bi-truck"></i> {item.status}
                        </li>}
                      <li className='text-white fs-11'><i className="bi bi-geo-alt-fill"></i> {item.location}</li>
                      <li className='text-white fs-10'><i className="bi bi-pencil-fill"></i> {item.remark}</li>
                      <li className='text-white fs-9 float-end fw-bold'><i className="bi bi-calendar"></i> {newd}</li>
                    </ul>
                  </Card.Body>
                </Card> : <Card key={item.checkpoint_id}>
                  <Card.Body>
                    <ul className='track_order_pop_ul'>
                      {index === 0 && item.status !== "Delivered" ?
                        <li className='fw-bold text-success'><img src="/icons8-truck.gif" className='w-5 h-5' alt="status" /> {item.status}</li> :
                        <li className='fw-bold text-success'><i className="bi bi-truck"></i> {item.status}
                        </li>}
                      <li className='text-danger fs-11'><i className="bi bi-geo-alt-fill"></i> {item.location}</li>
                      <li className='text-success fs-10'><i className="bi bi-pencil-fill"></i> {item.remark}</li>
                      <li className='text-primary fs-9 float-end fw-bold'><i className="bi bi-calendar"></i> {newd}</li>
                    </ul>
                  </Card.Body>
                </Card>

            )
          }) : <>No shipment detail available</>}

        </div>


      </div>
    </>
  )
}

export default TrackOrderPopup;